import { EventEmitter } from '@angular/core';
import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';
import { User } from '../../_models';

@Component({
    selector: 'header-user-console',
    templateUrl: './header-user-console.component.html',
    styleUrls: ['./header-user-console.component.css'],
    standalone: false
})
export class HeaderUserConsoleComponent implements OnInit, OnChanges {
  @Input('currentUser') currentUser: User;
  @Output() onRouteActivated: EventEmitter<boolean> = new EventEmitter<boolean>();

  public initials: string;
  public fullName: string;
  public email: string;

  public AccountSettingsEdit: boolean = false;

  constructor(
    public router: Router,
    private featureHelperService: FeatureHelperService
    ) { }
  
  ngOnInit() {
    let featureList = new Array<string>();
    featureList.push("AccountSettingsEdit");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);
    this.AccountSettingsEdit = currentUserFeatures.filter(f => f.feature === "AccountSettingsEdit")[0].enabled;

    this.setUserValues(this.currentUser);
  }

  ngOnChanges(): void {
    this.setUserValues(this.currentUser);
  }

  private setUserValues(user: User): void {
    this.initials = user.firstName.slice(0,1) + "" + user.lastName.slice(0,1);
    this.fullName = user.firstName + " " + user.lastName;
    this.email = user.email;
  }

  public logout(): void {
    this.router.navigate(["/login"]);
  }

  public routeActivated(): void {
    this.onRouteActivated.emit(true);
  }

}
